module.exports = __webpack_public_path__ + "static/media/bus.681f40eb.gif";